import { useEffect } from 'react';
import { TopBarContextProps } from './TopBarProvider';
import { useTopBarStore } from './TopBarStore';

// Headless component for top bar customization. You're probably looking for TopBarContent!
export function TopBar(props: TopBarContextProps) {
	const { setState, reset } = useTopBarStore();

	useEffect(() => {
		setState(props);
	}, [props, setState]);

	useEffect(() => {
		return () => {
			reset();
		};
	}, [reset]);

	return null;
}
